import * as React from 'react';
import { RegularField, AggregatedField } from '../types';
import { Link } from 'react-router-dom';

import styles from './cell.scss';

export const renderCell = (cell: RegularField, index?: number) => {

  const cellClassName = [
    cell.columnType,
    ...((!!(cell.iconUrl || cell.bgColour) && [styles.iconColumn]) || [])
  ].join(' ');

  const valueClassName = [
    styles.text,
    ...(((!!cell.onClick || !!cell.url) && [styles.drillDownCol]) || [])
  ].join(' ');

  const icon = !!cell.iconUrl && <img src={cell.iconUrl} alt={cell.value} />;

  const value = cell.url ?
    <Link tabIndex={0} className={valueClassName} to={cell.url}>{cell.value}</Link> :
    <span className={valueClassName}>{cell.value}</span>;

  const colorBox = !cell.iconUrl && !!cell.bgColour && <div
    className={styles.colorBox}
    style={{ backgroundColor: cell.bgColour }} />;

  return <td key={index}
    className={cellClassName}
    title={cell.tooltip}
    onClick={cell.onClick}
    tabIndex={!!cell.onClick ? 0 : null}>
    {icon}
    {colorBox}
    {value}
  </td>;
};

export const renderAggregateCell = (cell: RegularField | AggregatedField) => {

  const aggregateCell = cell as AggregatedField;

  if (aggregateCell.values) {
    return <td title={cell.tooltip} className="aggregate-cell">
      {aggregateCell.values.map((f, i) => <React.Fragment key={i}><div
        className={styles.boxContainer}
        onClick={f.onClick}
        title={f.tooltip}>
        {!!f.iconUrl && <img src={f.iconUrl} />}
        {!f.iconUrl && !!f.bgColour && <div
          className={styles.colorBox}
          style={{ backgroundColor: f.bgColour }} />}
        {!f.iconUrl && !f.bgColour && <span>{f.value} </span>}
        {!!f.aggregatedValue && <span className={styles.drillDownCol}>{f.aggregatedValue}</span>}
      </div>{' '}</React.Fragment>)}
    </td>;
  }

  return renderCell(cell as RegularField);
};
